import axios from 'axios';
import _ from 'lodash';
import { createProfile } from 'helpers/ContentHelper';
import { axiosErrorHandler, helperGetApiHeaders, helperGetApiRoute } from 'helpers/ApiHelper';

export const SET_GOOGLE_ONE_TAP = 'SET_GOOGLE_ONE_TAP';
export const SET_GOOGLE_EMAIL_AND_TOKEN = 'SET_GOOGLE_EMAIL_AND_TOKEN';
export const SET_IS_GOOGLE_SIGN_IN = 'SET_IS_GOOGLE_SIGN_IN';
export const SET_IS_GOOGLE_ONE_TAP_DISPLAYED = 'SET_IS_GOOGLE_ONE_TAP_DISPLAYED';
export const SET_IS_GOOGLE_SIGNED_IN_BROWSER = 'SET_IS_GOOGLE_SIGNED_IN_BROWSER';
export const SET_MVPD_PROVIDERS = 'SET_MVPD_PROVIDERS';
export const SET_NEXT_MVPD_PROVIDERS_PAGE = 'SET_NEXT_MVPD_PROVIDERS_PAGE';
export const SET_PREAUTHORIZED_RESOURCES = 'SET_PREAUTHORIZED_RESOURCES';
export const SET_RECOMMENDATION_ID = 'SET_RECOMMENDATION_ID';
export const SET_USER_AUTH_DATA = 'SET_USER_AUTH_DATA';
export const SET_USER_PROFILE_CONFIG = 'SET_USER_PROFILE_CONFIG';

const setNextMVPDProvidersPage = request => ({
  type: SET_NEXT_MVPD_PROVIDERS_PAGE,
  payload: request,
});

const fetchNextMVPDProvidersPageAction = (url, deviceId) => dispatch => {
  const pageType = 'mvpds';
  axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, deviceId }))
    .then(results => {
      const nextPage = _.get(results, 'data.view.next');
      if (nextPage) dispatch(fetchNextMVPDProvidersPageAction(nextPage, deviceId));
      dispatch(setNextMVPDProvidersPage(results));
    })
    .catch(axiosErrorHandler);
};

const setMVPDProviders = request => ({
  type: SET_MVPD_PROVIDERS,
  payload: request,
});

export const fetchMVPDProvidersAction = deviceId => dispatch => {
  const pageType = 'mvpds';
  axios
    .get(helperGetApiRoute(pageType), helperGetApiHeaders({ pathKey: pageType, deviceId }))
    .then(results => {
      const nextPage = _.get(results, 'data.view.next');
      if (nextPage) dispatch(fetchNextMVPDProvidersPageAction(nextPage, deviceId));
      dispatch(setMVPDProviders(results));
    })
    .catch(axiosErrorHandler);
};

export const setPreauthorizedResourcesAction = (resources = []) => ({
  type: SET_PREAUTHORIZED_RESOURCES,
  payload: resources,
});

export const setRecommendationIdAction = (recommendationId = null) => ({
  type: SET_RECOMMENDATION_ID,
  payload: recommendationId,
});

export const setUserAuthData = data => ({
  type: SET_USER_AUTH_DATA,
  payload: data,
});

export function setUserProfileConfig(data) {
  return async dispatch => {
    const { accessToken, profileId } = data;
    const { profile, profileConfig } = await createProfile(accessToken, profileId);
    dispatch({
      type: SET_USER_PROFILE_CONFIG,
      payload: { profile, profileConfig },
    });
  };
}

export const setIsGoogleSignIn = val => ({
  type: SET_IS_GOOGLE_SIGN_IN,
  payload: val,
});

export const setIsGoogleOneTapDisplayed = val => ({
  type: SET_IS_GOOGLE_ONE_TAP_DISPLAYED,
  payload: val,
});

export const setGoogleOneTap = ({ googleToken, googleOneTapEmail, isGoogleOneTap }) => ({
  type: SET_GOOGLE_ONE_TAP,
  googleToken,
  googleOneTapEmail,
  isGoogleOneTap,
});

export const setNewGoogleEmailAndToken = ({ googleEmail, googleToken }) => ({
  type: SET_GOOGLE_EMAIL_AND_TOKEN,
  googleEmail,
  googleToken,
});

export const setIsGoogleSignedInBrowser = ({ googleEmail, googleToken, isSignedIn }) => ({
  type: SET_IS_GOOGLE_SIGNED_IN_BROWSER,
  googleEmail,
  googleToken,
  isSignedIn,
});

export const setEmailSubmissionSFMC = ({ url, email, accessToken, deviceId, cb }) => {
  const headers = helperGetApiHeaders({ accessToken, deviceId });
  const apiUrl = window?.ExternalConfig?.api?.auth?.baseUrl;
  axios
    .post(
      `${apiUrl}prospect`,
      {
        email,
        url,
        prospect: 'foxnow',
        platform: 'web',
      },
      headers,
    )
    .then(result => cb(result))
    .catch(axiosErrorHandler);
};
